// The kit's parts on screens outside the levels: the title, the map's world icon and the inventor badges
import { DEG } from '../core/draw-helpers';
import type { CorePartType, Ctx2D, Gfx } from '../core/types';
import { drawPlank } from './plank';
import { drawPad } from './pad';
import { drawBowl } from './bowl';

/** Inventor badge (learn-tag) -> the part whose icon is shown on the badge */
export const TAG_ICONS: Record<string, CorePartType> = { ramp: 'plank', gravity: 'plank', spring: 'pad', lever: 'seesaw', friction: 'paint', direction: 'banana', pulley: 'stone' };

/** The title screen's plank, pad and bowl (the ball is drawn by the title) */
export function drawTitleParts(x: Ctx2D, t: number, gfx: Gfx) {
  drawPlank(x, 150, 90, 12 * DEG, 220, 18);
  drawPad(x, 370, 118, -10 * DEG, 100, 16);
  drawBowl(x, { x: 470, y: 140, w: 80 }, 0, t, gfx);
}

/** Breakfast's icon on the map: the bowl (around (0, 0)) */
export function drawGoalIcon(x: Ctx2D, gfx: Gfx) { drawBowl(x, { x: 0, y: 16, w: 46 }, 0, 0, gfx); }
